<div fxLayout="row" fxLayoutAlign="start center"
     class="bc-mono-white pointer radius-16 panel"
     ngClass.desktop="pt-40 pb-40 pl-24 pr-24 h-100"
     ngClass.mobile="pl-16 pr-16 pt-20 pb-20"
     [class.disabled]="viewModel.disabled"
     (click)="!viewModel.disabled && viewModel.click?.()"
     (mouseleave)="isHover = false" (mouseenter)="isHover = true">
    <div matRipple [matRippleDisabled]="viewModel.disabled" class="ripple radius-16"></div>
    <div fxLayout="row" fxLayoutAlign="start center" class="w-100 h-100" [ngClass]="viewModel.badgeTitle ? 'min-panel-content-height-extended' : 'min-panel-content-height'">
        <div class="w-56 ripple-ignore bc-primary-green-200 circle p-12"
             fxLayout="column"
             fxLayoutAlign="center center">
            @if (!viewModel.disabled || !isHover) {
                <ui-kit-svg class="i-32" name="{{viewModel.icon}}"/>
            }
            @if (viewModel.disabled && isHover) {
                <ui-kit-svg class="i-32 c-primary-gray-900" name="ic_lock"/>
            }
        </div>
        <div fxLayout="column" class="ml-24 ripple-ignore" fxLayoutAlign="space-between start" fxFlex>
            @if (viewModel.badgeTitle) {
                <div fxLayout="row" fxLayoutAlign="start center" class="container badge mb-24">
                    <div class="ml-4 t6">{{ viewModel.badgeTitle | translate }}</div>
                </div>
            }
            @if (!viewModel.disabled || !isHover) {
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3-semi-bold">{{ viewModel.title | translate }}</div>
                </div>
                <div class="t4 mt-8 pre-line">{{ viewModel.subtitle | translate }}</div>
            }
            @if (viewModel.disabled && isHover) {
                <div class="h3-semi-bold">
                    {{ viewModel.disabledTitle || 'i18n_af_panelDisabledTitle' | translate }}
                </div>
            }
        </div>
        @if (!viewModel.disabled) {
            <div fxLayout="column">
                <ui-kit-svg class="i-24 ripple-ignore ml-24 c-primary-gray-900" name="ic_arrow_right"/>
            </div>
        }
    </div>
</div>
